import React, {useEffect, useState} from 'react';
import $ from "../../utils/datatables";
import {Link} from "react-router-dom";
import moment from "moment";
import { toast } from 'react-toastify';
import {useSelector, useDispatch} from "react-redux";
import {GET_INPUT_DELIVERIES_BY_COMPANY_URL} from "../../api";
import {getCurrentUser} from "../../api/web";
import {SET_AUTH_USER} from "../../stores/auth";

const InputDelivery = (props) => {

    const token = localStorage.getItem('jwtToken');
    const dispatch = useDispatch();
    const authState = useSelector((state) => state.auth.user);
    const user = authState?.user;
    const [pacraId, setPacraId] = useState(null);

    useEffect(() => {
        if (user?.company?.pacra_id) {
            setPacraId(user.company.pacra_id);
            return;
        }
        if (!token) return;
        getCurrentUser()
            .then((data) => {
                if (data?.company?.pacra_id) {
                    setPacraId(data.company.pacra_id);
                    dispatch(SET_AUTH_USER({ user: data, token: authState?.token || token, isAuthenticated: true }));
                }
            })
            .catch(() => {});
    }, [token, user?.company?.pacra_id, authState?.token, dispatch]);

    useEffect(() => {
        if (!pacraId) return;
        let table = $('#input_delivery_table').DataTable({
            responsive: true,
            language: {
                searchPlaceholder: 'Search',
                sSearch: '',
                lengthMenu: '_MENU_ items/page',
                processing: '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Loading input deliveries</p>'
            },
            searching: true,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: function(data, callback) {
                const page = Math.floor(data.start / data.length) + 1;
                const url = GET_INPUT_DELIVERIES_BY_COMPANY_URL(pacraId, page, data.length);
                $.ajax(url, {
                    type: 'GET',
                    headers: {
                        Authorization: token ? 'Token ' + token : ''
                    },
                    success: function(res) {
                        const rawList = Array.isArray(res) ? res : (res?.results ?? res?.data ?? []);
                        const result = rawList.map((item) => ({ raw: item }));

                        callback({
                            recordsTotal: res?.count ?? result.length,
                            recordsFiltered: res?.count ?? result.length,
                            data: result
                        });
                    },
                    error: function(err) {
                        toast.error(err.statusText || 'Failed to load input deliveries', {position: "top-right", autoClose: 5000});
                        callback({ recordsTotal: 0, recordsFiltered: 0, data: [] });
                    }
                });
            },
            columns: [
                { data: "raw" },
                { data: "raw" },
                { data: "raw" },
                { data: "raw" },
                { data: "raw" },
                { data: "raw" },
                { data: "raw" }
            ],
            columnDefs: [
                {
                    render: function(data) {
                        return (data?.scheme?.scheme_name) ?? '—';
                    },
                    targets: 0
                },
                {
                    render: function(data) {
                        return data?.farmer ? `${data.farmer.first_name || ''} ${data.farmer.last_name || ''}`.trim() || '—' : '—';
                    },
                    targets: 1
                },
                {
                    render: function(data) {
                        return data?.agent ? `${data.agent.first_name || ''} ${data.agent.last_name || ''}`.trim() || '—' : '—';
                    },
                    targets: 2
                },
                {
                    render: function(data) {
                        const statusMap = {
                            pending: '<span class="badge text-white" style="background-color:#fd7e14">Pending</span>',
                            processed: '<span class="badge bg-info text-white">Processed</span>',
                            dispatched: '<span class="badge bg-primary text-white">Dispatched</span>',
                            received: '<span class="badge bg-success text-white">Received</span>'
                        };
                        return statusMap[data?.delivery_status] ?? (data?.delivery_status ?? '—');
                    },
                    targets: 3
                },
                {
                    render: function(data) {
                        const statusMap = {
                            pending: '<span class="badge text-white" style="background-color:#fd7e14">Pending</span>',
                            received: '<span class="badge bg-success text-white">Received</span>'
                        };
                        return statusMap[data?.farmer_receipt_status] ?? (data?.farmer_receipt_status ?? '—');
                    },
                    targets: 4
                },
                {
                    render: function(data) {
                        return data?.date_created ? moment(data.date_created).format("Do MMM, YYYY") : '—';
                    },
                    targets: 5
                },
                {
                    render: function(data) {
                        return `<a href="#" class="nav-link view_input_delivery"><i class="fa fa-eye"></i> View input delivery</a>`;
                    },
                    targets: 6
                }
            ]
        });

        table.on('click', '.view_input_delivery', function(e) {
            e.preventDefault();
            let rowData = table.row($(this).closest('tr')).data();
            if (rowData && rowData.raw && rowData.raw.id) {
                props.history.push(`/input_delivery/${rowData.raw.id}`);
            }
            return false;
        });

        return function cleanup() {
            if ($.fn.DataTable.isDataTable('#input_delivery_table')) {
                $('#input_delivery_table').DataTable().destroy();
                $('#input_delivery_table').empty();
            }
        };
    }, [pacraId, token, props.history]);

    const reloadTable = () => {
        if ($.fn.DataTable.isDataTable('#input_delivery_table')) {
            $('#input_delivery_table').DataTable().ajax.reload(null, false);
        }
    };

    return (
        <div className="content-body">
            <div className="container pd-x-0">
                <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                <li className="breadcrumb-item"><Link to="/dashboard">Menu</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Input Deliveries</li>
                            </ol>
                        </nav>
                        <h4 className="mg-b-0 tx-spacing--1">Input Deliveries</h4>
                    </div>
                </div>

                <div className="row row-xs">
                    <div className="col-md-12 mg-t-10">
                        <div className="card">
                            <div className="card-header d-flex align-items-center justify-content-between">
                                <h6 className="mg-b-0">Input Deliveries</h6>
                                <div className="d-flex tx-18">
                                    <Link to="#" onClick={reloadTable} className="link-03 lh-0"><i className="icon ion-md-refresh"></i></Link>
                                </div>
                            </div>
                            <div className="card-body table-responsive">
                                <table id="input_delivery_table" className="table table-hover" style={{width: "100%"}}>
                                    <thead>
                                        <tr>
                                            <th className="wd-15p">Scheme</th>
                                            <th className="wd-15p">Farmer</th>
                                            <th className="wd-15p">Agent</th>
                                            <th className="wd-12p">Delivery Status</th>
                                            <th className="wd-12p">Farmer Receipt</th>
                                            <th className="wd-12p">Date Created</th>
                                            <th className="wd-12p">Action</th>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InputDelivery;
